import React from 'react'
import Form from 'react-bootstrap/Form'

export function SliderInput(props: {
  value: number
  setFieldValue: (field: string, value: number) => void
  label: string
  name: string
  max: number
  min: number
  step: number
  /** Tighter vertical layout (e.g. padding group). */
  compact?: boolean
}) {
  const {value, setFieldValue, name, max, min, step, compact = false} = props

  const handleOnChange = (value: number) => {
    setFieldValue(name, value)
  }

  return (
    <Form.Group
      className={compact ? 'mb-0 template-editor-slider--compact' : 'mb-3 pb-2'}
    >
      <Form.Label
        className={compact ? 'mb-0' : undefined}
        style={
          compact
            ? {fontSize: '0.68rem', lineHeight: 1.15, marginBottom: 1}
            : undefined
        }
      >
        {props.label} - {value}
      </Form.Label>
      <Form.Range
        className={compact ? 'template-editor-range--compact' : undefined}
        onChange={(e) => {
          handleOnChange(Number(e.target.value))
        }}
        value={value}
        max={max}
        min={min}
        step={step}
      />
    </Form.Group>
  )
}
